module.exports = __webpack_public_path__ + "img/WEBweihu.163e356e.png";